<template>
    <button v-on="$listeners" class="uibutton" :id="id" :disabled="disabled" :type="type"
            :style="{ height: h, width: w }"
            :class="{
              'uibutton--loading': loading,
              'uibutton--reverse': reverse,
              'uibutton--compact': compact,
            }">
        <span><slot/></span>
        <div class="loader"></div>
    </button>
</template>

<script>
export default {
  props: {
    id: { type: String, default: '' },
    type: { type: String, default: '' },
    h: { type: String, default: 'unset' },
    w: { type: String, default: 'unset' },
    disabled: Boolean,
    loading: Boolean,
    reverse: Boolean, // Reverse colors
    compact: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.uibutton {
    display: inline-block;
    position: relative;
    border: 1px solid #D90E16;
    border-radius: 6px !important;
    width: 162px;
    min-width: 130px;
    height: 36px;
    line-height: 24px;
    font-size: 17px;
    font-weight: 600;
    color: #D90E16;
    text-align: center;
    text-decoration: none;
    margin-bottom: 0;
    background: white;
    padding: 4px 8px;

    &--compact {
      font-size: 15px;
      line-height: 24px;
      padding: 2px 12px;
      min-width: 80px;
      height: 28px;
      border-radius: 4px !important;
    }

    .loader {
        display: none;
        position: absolute;
        top: calc(50% - 8px);
        left: calc(50% - 8px);
    }
    &--loading {
        pointer-events: none;
        cursor: default;

        span {
            visibility: hidden;
        }
        .loader {
            display: block;
        }
    }

    &--reverse {
        color: white;
        background: #D90E16;
        .loader {
          border-color: white;
          border-top-color: #D90E16;
        }
    }
}

.uibutton:enabled {
  cursor: pointer;
  @media (hover:hover) {
    &:hover {
      color: white;
      background: linear-gradient(90deg, #D90E16 0%, #D90E16 37.5%, #F00281 100%);
      border-color: #D90E16;
    }
  }

  &--reverse {
    @media (hover:hover) {
      &:hover {
        color: #D90E16;
        background: white;
      }
    }
  }
}

.uibutton:disabled {
  opacity: 0.7
}

.uibutton.button-gray {
  border: solid 1px $gray1;
  color: $gray1;
}
.uibutton.button-gray:enabled {
    @media (hover:hover) {
        &:hover {
            color: #FFF;
            background-color: $gray1;
        }
    }
}
</style>
